import { FC } from 'react';
import { styled, Container, Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from './vertical/header/Header';
import SidebarV2 from './vertical/sidebar/SidebarV2';
import { RootState, useAppSelector } from '@shared/store';
import { StartStopProvider } from '@features/Admin/Campaign/contexts/startstop.provider';

const MainWrapper = styled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
  width: '100%',
}));

const PageWrapper = styled('div')(() => ({
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  zIndex: 1,
  width: '100%',
  backgroundColor: 'transparent',
  overflow: 'auto',
  scrollbarGutter: 'stable',
  height: '100vh',
}));

export const FullLayout: FC = () => {
  const customizer = useAppSelector((state: RootState) => state.customizer);
  return (
    <StartStopProvider>
      <MainWrapper>
        <SidebarV2 />
        <PageWrapper
          className="page-wrapper"
          sx={{
            ...(customizer.isCollapse && { ml: `${customizer.MiniSidebarWidth}px` }),
          }}>
          <Header />
          <Container
            sx={{
              height: '100%',
              maxWidth: customizer.isLayout === 'boxed' ? 'lg' : '100%!important',
            }}>
            <Box
              sx={{
                minHeight: 'calc(100vh - 170px)',
                height: '100%',
                position: 'relative',
                '> div': { height: '100%' },
              }}>
              <Outlet />
            </Box>
          </Container>
        </PageWrapper>
      </MainWrapper>
    </StartStopProvider>
  );
};
